module.exports = __webpack_public_path__ + "static/media/workshop.0c1aef5f.svg";